import { DestroyRef, Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { VcDataService } from './vc-data';

@Injectable({
  providedIn: 'root',
})
export class IframeCommunication {
  private dataSubject = new BehaviorSubject<any>(null);
  private vcDataService = inject(VcDataService);
  private destroyRef = inject(DestroyRef);
  public data$ = this.dataSubject.asObservable();
  private isListening = false;

  async init() {
    const iframe = window.self != window.top;
    if (!iframe) {
      return;
    }
    return new Promise<void>((resolve) => {
      this.startListening();
      this.initiateHandshake();
      resolve();
    });
  }

  private startListening() {
    if (this.isListening) {
      return;
    }
    this.isListening = true;
    window.addEventListener('message', this.handleMessage);
    this.destroyRef.onDestroy(() => {
      window.removeEventListener('message', this.handleMessage);
    });
  }

  private initiateHandshake() {
    this.sendToHost({ type: 'VAS_READY' });
  }

  private handleMessage = (event: MessageEvent) => {
    if (!environment.allowedIframeOrigin?.includes(event.origin)) {
      return;
    }
    if (!event.data) return;
    if (event.data.type === 'INITIAL_DATA') {
      this.dataSubject.next(event.data.payload?.appData);
    }
    // else if (event.data.type === 'DATA_UPDATE') {
    //   // this.dataSubject.next(event.data.payload);
    // }
  };

  sendToHost(message: { type: string; payload?: any }): void {
    if (window.parent && window.parent !== window) {
      const parentOrigin = document.referrer ? new URL(document.referrer).origin : '';
      if (!environment.allowedIframeOrigin?.includes(parentOrigin)) return;
      if (!this.vcDataService.hostOrigin()) {
        this.vcDataService.hostOrigin.set(parentOrigin);
      }
      window.parent.postMessage(message, parentOrigin);
    }
  }

}
